import React from 'react'
import AERMETUG from '../../../docs/aermet_userguide_v23132.pdf'
import AERMODUG from '../../../docs/aermod_userguide_v23132.pdf'
import AERMODAQUG from '../../../docs/AQcast_AERMOD_User_Guide.pdf'


export default class About extends React.Component {
    render() {
        return (
            <div>
                <h2>AERMOD</h2>

                <p>EPA approved dispersion model for NAAQS and other hazardous air pollutants. Using our AQcast system on the Amazon cloud, AER
                can run AERMOD and all of its pre-processors including (bpipprm, aermap, aermet, aerminute, and aersurface) for a facility
                with provided source parameters and facility location.  The AQcast: AERMOD system uses the latest approved versions and
                updates are done automatically with no user action required.  The system will download all necessary terrain and landuse files. Once the
                meteorological options and location are chosen, all data will be gathered and processed. Receptor grids can be specified and run
                quickly taking advantage of the Amazon Web Services cloud computing.  ESRI GIS shapefiles of facility buildings and fence lines can
                be uploaded and input into the model or the shapes can be drawn on the map provided in the User Interface.  All input data and files
                will then be organized and AERMOD will be run.  Following the successful completion of AERMOD, various plots and summary files will be
                displayed on an access portal, and a link to download all modeling files is provided.</p>
                <h3>Helpful User Guides</h3>
                <li>
                    <a href={AERMODAQUG} target = "_blank">AQcast: AERMOD User Guide</a>
                </li>
                <li>
                    <a href={AERMETUG} target = "_blank">AERMET v23132 User Guide</a>
                </li>

                <li>
                    <a href={AERMODUG} target = "_blank">AERMOD v User Guide</a>
                </li>
                <br></br>
                <h4>Major Updates</h4>
                2024-10-21 : Update versions of AERMET and AERMOD tO 23132, and no radiosonde data is IRGA format not FSL.
                <br></br>2020-07-18 : Add the option for area sources, Split AERMOD runs, and hourly emission files.
                <br></br>2020-06-20 : Add the option to load a previous project, buildings, fencelines, sources. Add to a previous or uploaded building/fenceline files
                <br></br>2020-05-15 : Updated AERSURFACE to version 20060
            </div>
        );
    }
}
